<div class="maintenance-container">
  <div class="logo-section">
    <img src="assets/images/excuela-logo-white.svg" [alt]="'maintenancePage.logoAlt' | translate" class="logo">
  </div>
  
  <div class="message-section">
    <div class="maintenance-icon">
      <i class="fas fa-wrench"></i>
    </div>
    <h1 class="title">{{ 'maintenancePage.title' | translate }}</h1>
    <p class="message">
      {{ 'maintenancePage.message' | translate }}
    </p>
  </div>
</div>

